












import {Component, Vue, Prop} from 'vue-property-decorator'
import {ItemType, Room, InventoryItem} from '@/store/types'
import {Getter, Mutation, Action} from 'vuex-class'
import {Touch, ListItemRound} from '@/components/common'

@Component({
  components: {
    ListItemRound,
    Touch,
  },
})
export default class InventoryItemRound extends Vue {
  @Prop({type: Object, required: true}) public item!: InventoryItem
  @Prop({type: Number, required: true}) public index!: number

  @Getter('activeRoom') public activeRoom!: Room
  @Getter('activeItemType') public activeItemType!: ItemType
  @Mutation('setAddedItem') public setAddedItem!: any
  @Mutation('setActiveItemType') public setActiveItemType!: any
  @Mutation('setInventoryNewItemOverlay') public setInventoryNewItemOverlay!: any
  @Mutation('setInventoryAddMultipleItemsOverlay') public setInventoryAddMultipleItemsOverlay!: any
  @Mutation('setAddedItemTransition') public setAddedItemTransition!: any
  @Action('addRoomItem') public addRoomItem!: any
  @Action('openInventoryAddedItem') public openInventoryAddedItem!: any

  public loading = false

  public get active() {
      return this.activeItemType && (this.activeItemType.id === this.item.id)
  }

  public addItem(item: ItemType) {

    if (item.custom) {
      return this.setCustomItem(item)
    }

    this.loading = true
    this.setAddedItemTransition(true)

    const data: any = {
      inventory_id: item.id,
      lead_room_id: this.activeRoom.id,
      quantity: 1,
    }
    this.addRoomItem(data).then(() => {
      this.loading = false
    })
    this.openInventoryAddedItem()
    this.setAddedItem(item)
    const scrollElement = document.getElementById('scroll')
    const scrollWrapper = document.getElementById('scrollWrapper')
    if (scrollElement) {
      scrollElement.scrollLeft = 0
    }
    if (scrollWrapper) {
      scrollWrapper.scrollTop = 0
    }
  }

  public setCustomItem(item: ItemType) {
    this.setActiveItemType(item)
    return this.setInventoryNewItemOverlay(true)
  }

  public setMultipleItem(item: ItemType) {
    if (!item.custom) {
      this.closeKeyboard()
      this.setActiveItemType(item)
      this.setInventoryAddMultipleItemsOverlay(true)
    }
  }

  public closeKeyboard() {
    (document.activeElement as HTMLElement).blur()
  }
}

